<script setup>
import { MapSimple } from '@/app/components';
import { pushToDataLayer } from '@/ui/scripts/analytics/analytics.methods';

function ctaClickHandler(event) {
  pushToDataLayer(
    'project_page_project_hero_cta',
    'link_text',
    'link_url',
    event.target.text,
    event.target.href,
  );
}
</script>

<template>
  <MapSimple @ctaClick="ctaClickHandler" />
  <LoadingOverlay />
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/units';

.c-project-hero-mini-map {
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>
